const formatTimeForApi = time => {
    if (!time) {
        return null;
    }

    if (time.includes('T')) {
        return time;
    }

    const normalizedTime = time.length === 5 ? `${time}:00` : time;
    return `1970-01-01T${normalizedTime}`;
};

export const transformAdvertisement = data => {
    const payload = {
        contractorId: data.contractorId,
        name: data.name,
        deviceGroupIds: data.deviceGroupIds,
        isPermanent: Boolean(data.isPermanent),
        isContinuous: Boolean(data.isContinuous),
        isActive: data.isActive === undefined ? true : Boolean(data.isActive),
    };

    const image = Array.isArray(data.advertisementImage) ? data.advertisementImage[0] : data.advertisementImage;

    if (image?.rawFile instanceof File) {
        payload.image = image;
    } else if (image instanceof File) {
        payload.image = { rawFile: image, title: image.name };
    }

    if (data.isPermanent) {
        payload.startDate = null;
        payload.endDate = null;
    } else {
        payload.startDate = data.startDate ?? null;
        payload.endDate = data.endDate ?? null;
    }

    if (data.isContinuous) {
        payload.startTime = null;
        payload.endTime = null;
    } else {
        payload.startTime = formatTimeForApi(data.hourFrom);
        payload.endTime = formatTimeForApi(data.hourTo);
    }

    return payload;
};
